import { datadogRum } from "@datadog/browser-rum";

type CostLike = {
  cost?: number | string;
  originalCost?: number | string;
};

/**
 * Resolves the total tow cost to charge the customer.
 * All partners must use the original cost, per B-3013384
 */
export const resolveTotalTowCost = (benefitsTowCostInfo: CostLike): number => {
  const totalTowCost = Number(benefitsTowCostInfo.originalCost) || 0;
  if (!benefitsTowCostInfo.originalCost) {
    // originalCost is expected to always be populated post-B-3013384; report to Datadog so a
    // missing/invalid value (which silently resolves to a $0 tow cost) can be caught and investigated.
      datadogRum.addAction("towCost.originalCostMissing", { benefitsTowCostInfo });
  }
  return totalTowCost;
};
